import { Label } from "components/atoms";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import {
  PiCheckCircle,
  PiClock,
  PiWarningCircle,
  PiXCircle,
  PiHourglassSimpleMedium,
} from "react-icons/pi";
import { SETTLEMENT_ORDER_STATUS } from "services/settlementOrder/enums";
import { IColorProp } from "types/components/components.interface";

export interface ILabeledSettlementOrderStatusProps {
  status: SETTLEMENT_ORDER_STATUS;
}

interface ILabeledSettlementOrderStatusParams extends IColorProp {
  status: SETTLEMENT_ORDER_STATUS;
  icon: ReactNode;
}

  // {
  //   status: REPORT_GENERATION_STATUS.Waiting,
  //   color: 'black',
  //   icon: <PiClock />,
  // },
  // {
  //   status: REPORT_GENERATION_STATUS.Canceled,
  //   color: 'transparent',
  //   icon: <PiXCircle />,
  // },
  // {
  //   status: REPORT_GENERATION_STATUS.Done,
  //   color: 'green',
  //   icon: <PiSealCheck />,
  // },
  // {
  //   status: REPORT_GENERATION_STATUS.Error,
  //   color: 'red',
  //   icon: <PiSealWarning />,
  // },
  // {
  //   status: REPORT_GENERATION_STATUS.InProgress,
  //   color: 'orange',
  //   icon: <PiSeal />,
  // },

const labeledSettlementOrderParams: ILabeledSettlementOrderStatusParams[] = [
  {
    status: SETTLEMENT_ORDER_STATUS.waiting,
    color: "black",
    icon: <PiClock />,
  },
  {
    status: SETTLEMENT_ORDER_STATUS.inProgress,
    color: "blue",
    icon: <PiHourglassSimpleMedium />,
  },
  {
    status: SETTLEMENT_ORDER_STATUS.done,
    color: "green",
    icon: <PiCheckCircle />,
  },
  {
    status: SETTLEMENT_ORDER_STATUS.error,
    color: "red",
    icon: <PiWarningCircle />,
  },
  {
    status: SETTLEMENT_ORDER_STATUS.canceled,
    color: "gray",
    icon: <PiXCircle />,
  },
];

const LabeledSettlementOrderStatus = ({
  status,
}: ILabeledSettlementOrderStatusProps) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledSettlementOrderParams.find((params) => params.status === status) ??
    labeledSettlementOrderParams[0];
  return (
    <Label
      size="compact"
      color={labeledParams.color}
      title={t(
        `enum.SETTLEMENT_ORDER_STATUS.${
          SETTLEMENT_ORDER_STATUS[labeledParams.status]
        }`
      )}
    >
      {labeledParams.icon}{" "}
      {t(
        `enum.SETTLEMENT_ORDER_STATUS.${
          SETTLEMENT_ORDER_STATUS[labeledParams.status]
        }`
      )}
    </Label>
  );
};

export default LabeledSettlementOrderStatus;
